import {formatter} from "../../../global/formatter.js";

export const planPricesMixin = {
	methods: {
		findMemberPrice(member) {
			let price = null;
			
			this.plan.familyCost.forEach(function (cost, index) {
				if (cost.consumerId == member.consumerId) {
					price = cost.price;
				}
			});
			return price
		},
		getAge(dateString) {
			let today = new Date();
			let birthDate = new Date(dateString);
			let age = today.getFullYear() - birthDate.getFullYear();
			let m = today.getMonth() - birthDate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--;
			}
			return age;
		},
		inRange(x, min, max) {
			return x >= min && x <= max;
		},
		getPrices(planCost) {
			let highest = Number.MIN_SAFE_INTEGER;
			let lowest = Number.MAX_SAFE_INTEGER;
			let isSamePrice = false;
			planCost.forEach(function (plan, index) {
				if (plan.highestCost > highest) {
					highest = plan.highestCost;
				}
				if (plan.lowestCost < lowest) {
					lowest = plan.lowestCost;
				}
			});
			if (highest == lowest) {
				isSamePrice = true;
			}
			return {
				highestPlanPrice: highest,
				lowestPlanPrice: lowest,
				isSamePrice: isSamePrice
			}
		},
		getPlanPriceRange(planCost) {
			let highest = Number.MIN_SAFE_INTEGER;
			let lowest = Number.MAX_SAFE_INTEGER;
			let isSamePrice = false;
			planCost.forEach(function (tier, index) {
				if (tier.price > highest) {
					highest = tier.price;
				}
				if (tier.price < lowest) {
					lowest = tier.price;
				}
			});
			if (highest == lowest) {
				isSamePrice = true;
			}
			return {
				highestPlanPrice: highest,
				lowestPlanPrice: lowest,
				isSamePrice: isSamePrice
			}
		}
	}
};